import signup from "./signup";
import facebookSignup from "./facebookSignup";
import { socialProviders } from "../socialProviders";

export function getSignupMethod(signupConfig) {
  if (isNormalSignup(signupConfig)) {
    return signup;
  } else if (isFacebookSignup(signupConfig)) {
    return facebookSignup;
  } else if (isOTPSignup(signupConfig)){
    return signup
  }
  else if(isSignupWithSSO) {
    return signup;
  }
}

function isNormalSignup(config) {
  return !!(config.username && config.password);
}
function isSignupWithSSO() {
  return config.signupWithSSO && config.token;
}
function isFacebookSignup(config) {
  return config.provider === socialProviders.FACEBOOK;
}

function isOTPSignup(config){
  return config && config.otp
}